import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestError } from '@/app/common/types_and_interfaces.ts'
import { FamilyApplicationQueryKeys } from '@/queries/family_applications/queries.ts'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'
import {
  updateStudentScholarshipAward,
  UpdateStudentScholarshipAwardParams,
  UpdateStudentScholarshipAwardResponse,
} from '@/queries/program_purses/requests.ts'

export const useUpdateStudentScholarshipAward = (
  options?: UseMutationOptions<
    UpdateStudentScholarshipAwardResponse,
    RequestError,
    UpdateStudentScholarshipAwardParams
  >
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateStudentScholarshipAward,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: FamilyApplicationQueryKeys.list_all,
      })
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSES(variables.programId),
      })
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSE_DETAILS(
          String(variables.programPurseId),
          variables.programId
        ),
      })
      queryClient.invalidateQueries({
        queryKey: [
          'TRANSACTION_LOGS',
          variables.programId,
          variables.programPurseId,
        ],
      })

      options?.onSuccess?.(data, variables, context)
    },
    onError: options?.onError,
    onSettled: options?.onSettled,
  })
}
